import React from 'react';

const HelpToBuyWithTextLogo = () => {
    return (
        <svg
            width="40"
            height="51"
            viewBox="0 0 40 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="help-to-buy"
        >
            <rect width="40" height="51" rx="2" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.1847 41.5848H11.2282C11.5875 41.5848 11.8156 41.3656 11.8156 41.0228C11.8156 40.6143 11.4866 40.4998 11.1362 40.4998H10.1847V41.5848ZM10.1847 40.1483H11.0178C11.4912 40.1483 11.6842 39.9773 11.6842 39.6475C11.6842 39.2131 11.3772 39.1515 11.0178 39.1515H10.1847V40.1483ZM9.76855 38.7998H10.9037C11.1801 38.7998 11.544 38.7998 11.732 38.9145C11.9381 39.0374 12.1003 39.2611 12.1003 39.5689C12.1003 39.9029 11.925 40.153 11.6357 40.2715V40.2807C12.0216 40.3593 12.2319 40.6496 12.2319 41.036C12.2319 41.4973 11.9033 41.9365 11.2807 41.9365H9.76855V38.7998Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.1113 40.7634C13.9665 40.8689 13.6861 40.8734 13.4363 40.9176C13.1909 40.9612 12.9806 41.049 12.9806 41.3265C12.9806 41.5719 13.1909 41.6601 13.4186 41.6601C13.9101 41.6601 14.1113 41.3526 14.1113 41.1457V40.7634ZM14.7161 41.9272C14.6505 41.9675 14.5674 41.9889 14.4492 41.9889C14.2563 41.9889 14.1335 41.884 14.1335 41.6382C13.9274 41.8796 13.6515 41.9889 13.3357 41.9889C12.9236 41.9889 12.5864 41.8047 12.5864 41.3526C12.5864 40.8383 12.9671 40.7286 13.3533 40.6537C13.765 40.5748 14.1159 40.6014 14.1159 40.3202C14.1159 39.9947 13.8483 39.9423 13.6118 39.9423C13.296 39.9423 13.0637 40.039 13.0462 40.3726H12.6737C12.6959 39.8101 13.1299 39.6128 13.6339 39.6128C14.0417 39.6128 14.484 39.7047 14.484 40.2365V41.405C14.484 41.5804 14.484 41.6601 14.6026 41.6601C14.6331 41.6601 14.6681 41.6557 14.7161 41.6382V41.9272Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.5989 40.3943C16.5417 40.1091 16.3447 39.9423 16.0378 39.9423C15.4987 39.9423 15.3319 40.3682 15.3319 40.8295C15.3319 41.2467 15.5205 41.6601 15.994 41.6601C16.3535 41.6601 16.5682 41.4493 16.6164 41.1066H16.9975C16.9144 41.6601 16.5682 41.9889 15.9983 41.9889C15.3059 41.9889 14.9375 41.5062 14.9375 40.8295C14.9375 40.1482 15.2885 39.6128 16.0072 39.6128C16.52 39.6128 16.9317 39.8545 16.9846 40.3943H16.5989Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.437 38.7998H17.8098V40.6586L18.8442 39.6655H19.3441L18.4457 40.4913L19.4099 41.9366H18.9362L18.1606 40.7508L17.8098 41.0755V41.9366H17.437V38.7998Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.2634 40.5833C21.2452 40.2279 20.9784 39.9423 20.6098 39.9423C20.2195 39.9423 19.9874 40.2365 19.9614 40.5833H21.2634ZM21.6224 41.2162C21.5212 41.7172 21.1622 41.9889 20.6539 41.9889C19.9308 41.9889 19.5888 41.4881 19.5669 40.7939C19.5669 40.1131 20.0137 39.6128 20.6322 39.6128C21.4337 39.6128 21.6789 40.3637 21.6576 40.9132H19.9614C19.9482 41.3084 20.1718 41.6601 20.6671 41.6601C20.9742 41.6601 21.1887 41.5106 21.2546 41.2162H21.6224Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.0177 41.66C23.5168 41.66 23.7091 41.2294 23.7091 40.8032C23.7091 40.3552 23.5082 39.9422 22.9951 39.9422C22.4871 39.9422 22.3159 40.3774 22.3159 40.8213C22.3159 41.2468 22.5353 41.66 23.0177 41.66ZM24.0693 41.9365H23.6965V41.6291H23.6879C23.5648 41.8795 23.2756 41.9888 22.9645 41.9888C22.2679 41.9888 21.9219 41.4358 21.9219 40.794C21.9219 40.153 22.264 39.6128 22.9561 39.6128C23.1882 39.6128 23.521 39.7002 23.6879 39.9688H23.6965V38.7998H24.0693V41.9365Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.9232 39.9424C26.4235 39.9424 26.231 40.3727 26.231 40.7988C26.231 41.2468 26.4322 41.6602 26.9452 41.6602C27.4534 41.6602 27.6246 41.2251 27.6246 40.7815C27.6246 40.3552 27.4054 39.9424 26.9232 39.9424ZM25.8711 38.7998H26.2437V39.973H26.253C26.3757 39.7229 26.6646 39.6129 26.9765 39.6129C27.6728 39.6129 28.0188 40.1663 28.0188 40.8077C28.0188 41.4494 27.6773 41.989 26.9851 41.989C26.7525 41.989 26.4195 41.9012 26.253 41.6339H26.2437V41.9366H25.8711V38.7998Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.3465 42.2398C29.1751 42.6834 29.0216 42.8461 28.6887 42.8461C28.6012 42.8461 28.5136 42.8368 28.4298 42.8063V42.4635C28.5003 42.4856 28.5747 42.5161 28.649 42.5161C28.8024 42.5161 28.886 42.4417 28.9557 42.3099L29.1091 41.9231L28.2109 39.6655H28.6318L29.2938 41.5236H29.3018L29.9378 39.6655H30.3319L29.3465 42.2398Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00781 43.0171H4.42404V44.3648H6.07234V43.0171H6.48879V46.1531H6.07234V44.7164H4.42404V46.1531H4.00781V43.0171Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.1792 43.0171H7.7485L8.73493 45.6523L9.72576 43.0171H10.2953V46.1531H9.90108V43.5437H9.89205L8.91476 46.1531H8.55984L7.5821 43.5437H7.57352V46.1531H7.1792V43.0171Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5454 45.762C14.3044 46.0914 13.9101 46.2277 13.5419 46.2277C12.6081 46.2277 12.0518 45.463 12.0518 44.6458C12.0518 43.7327 12.5514 42.9419 13.5419 42.9419C14.2257 42.9419 14.7692 43.2493 14.8874 43.9833H14.4711C14.3877 43.5084 14.0067 43.2937 13.5419 43.2937C12.7837 43.2937 12.468 43.9523 12.468 44.6243C12.468 45.2786 12.8449 45.876 13.5419 45.876C14.186 45.876 14.5719 45.4237 14.5454 44.8527H13.5461V44.5014H14.9182V46.1528H14.6551L14.5454 45.762Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.4474 45.8762C16.8375 45.8762 17.1528 45.5691 17.1528 45.0201C17.1528 44.4662 16.8375 44.1587 16.4474 44.1587C16.0574 44.1587 15.7418 44.4662 15.7418 45.0201C15.7418 45.5691 16.0574 45.8762 16.4474 45.8762ZM16.4474 43.8296C17.166 43.8296 17.5474 44.3521 17.5474 45.0201C17.5474 45.6828 17.166 46.2061 16.4474 46.2061C15.7286 46.2061 15.3472 45.6828 15.3472 45.0201C15.3472 44.3521 15.7286 43.8296 16.4474 43.8296Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.0062 46.1528H18.6073L17.7659 43.8818H18.1824L18.8181 45.7749H18.8264L19.4445 43.8818H19.8348L19.0062 46.1528Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.751 44.8C21.7339 44.4443 21.4658 44.1587 21.0977 44.1587C20.7073 44.1587 20.4753 44.4536 20.4495 44.8H21.751ZM22.1105 45.4322C22.0093 45.933 21.6498 46.2061 21.1415 46.2061C20.4182 46.2061 20.0758 45.7053 20.0547 45.0112C20.0547 44.3304 20.5017 43.8296 21.1193 43.8296C21.9219 43.8296 22.1673 44.5805 22.1452 45.1296H20.4495C20.4357 45.5244 20.6594 45.8762 21.1547 45.8762C21.4614 45.8762 21.6758 45.7271 21.742 45.4322H22.1105Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.5164 43.8822H22.866V44.3612H22.8753C23.055 43.9963 23.3047 43.8162 23.7075 43.8298V44.2247C23.108 44.2247 22.8886 44.5672 22.8886 45.1432V46.1532H22.5164V43.8822Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.0669 43.882H24.4176V44.2419H24.4262C24.5842 43.9606 24.8382 43.8296 25.1628 43.8296C25.7592 43.8296 25.9436 44.1724 25.9436 44.6595V46.1529H25.5708V44.6152C25.5708 44.3389 25.395 44.1587 25.1106 44.1587C24.659 44.1587 24.4393 44.4614 24.4393 44.8702V46.1529H24.0669V43.882Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.5034 43.882H26.8538V44.2155H26.8626C27.0297 43.9606 27.2842 43.8296 27.5947 43.8296C27.8707 43.8296 28.1256 43.9392 28.2174 44.2155C28.3708 43.9742 28.6384 43.8296 28.9267 43.8296C29.3791 43.8296 29.6811 44.0182 29.6811 44.4887V46.1529H29.3087V44.6639C29.3087 44.3828 29.2349 44.1587 28.8705 44.1587C28.5109 44.1587 28.2786 44.3872 28.2786 44.7388V46.1529H27.9063V44.6639C27.9063 44.3692 27.8142 44.1587 27.4813 44.1587C27.0384 44.1587 26.876 44.567 26.876 44.7388V46.1529H26.5034V43.882Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.8135 44.8C31.7953 44.4443 31.5285 44.1587 31.1603 44.1587C30.77 44.1587 30.5375 44.4536 30.5116 44.8H31.8135ZM32.1725 45.4322C32.0718 45.933 31.7124 46.2061 31.2038 46.2061C30.4815 46.2061 30.1395 45.7053 30.1172 45.0112C30.1172 44.3304 30.5642 43.8296 31.1818 43.8296C31.9838 43.8296 32.2303 44.5805 32.2078 45.1296H30.5116C30.4984 45.5244 30.7218 45.8762 31.2171 45.8762C31.5241 45.8762 31.7384 45.7271 31.8044 45.4322H32.1725Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.5945 43.882H32.9449V44.2419H32.9536C33.1115 43.9606 33.3655 43.8296 33.6901 43.8296C34.2866 43.8296 34.4708 44.1724 34.4708 44.6595V46.1529H34.0981V44.6152C34.0981 44.3389 33.9226 44.1587 33.6383 44.1587C33.1863 44.1587 32.9671 44.4614 32.9671 44.8702V46.1529H32.5945V43.882Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.5468 43.882H35.9986V44.2111H35.5468V45.6212C35.5468 45.7928 35.5949 45.8238 35.8266 45.8238H35.9986V46.1529H35.7137C35.3277 46.1529 35.1747 46.0743 35.1747 45.6567V44.2111H34.7891V43.882H35.1747V43.2012H35.5468V43.882Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.6272 21.0324C35.6272 29.6837 28.6304 36.6962 19.9988 36.6962C11.3673 36.6962 4.37036 29.6837 4.37036 21.0324C4.37036 12.3813 11.3673 5.36865 19.9988 5.36865C28.6304 5.36865 35.6272 12.3813 35.6272 21.0324Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9987 37.07C11.1771 37.07 4 29.8769 4 21.0349C4 12.1931 11.1771 5 19.9987 5C28.8206 5 35.9974 12.1931 35.9974 21.0349C35.9974 29.8769 28.8206 37.07 19.9987 37.07ZM19.9987 5.74213C11.5853 5.74213 4.74033 12.6023 4.74033 21.0349C4.74033 29.4677 11.5853 36.3279 19.9987 36.3279C28.4119 36.3279 35.2568 29.4677 35.2568 21.0349C35.2568 12.6023 28.4119 5.74213 19.9987 5.74213Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.4379 17.5295V22.9735H15.2134H11.4363H11.0469V22.383V17.5295H9.80118L9.40234 16.6024L15.0389 10.5721L15.4385 10.145L15.8374 10.5721L21.4732 16.6024L21.0743 17.5295H19.8026H15.4379ZM19.0125 11.1816H17.6311V11.9455L19.0125 13.4236V11.1816Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8719 22.9733V21.0552H17.3077V22.9733H16.0859V18.1787H17.3077V19.98H18.8719V18.1787H20.0943V22.9733H18.8719Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.3393 21.5021H21.6501C21.7151 21.9297 22.0702 22.1827 22.4908 22.1827C22.7815 22.1827 22.969 22.0661 23.1434 21.8454H24.2429C23.9324 22.5647 23.2988 23.0897 22.4908 23.0897C21.4437 23.0897 20.5903 22.2345 20.5903 21.1849C20.5903 20.1415 21.4175 19.2539 22.4713 19.2539C23.5703 19.2539 24.3655 20.1351 24.3655 21.2175C24.3655 21.3143 24.3593 21.4051 24.3393 21.5021ZM22.478 20.1611C22.09 20.1611 21.7476 20.388 21.6632 20.7767H23.2923C23.208 20.388 22.8652 20.1611 22.478 20.1611Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.8311 22.9733H25.9041V18.1787H24.8311V22.9733Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.6409 23.0966C28.214 23.0966 27.8523 22.967 27.5613 22.6495V24.1721H26.4883V19.3776H27.4963V19.7727H27.5033H27.5155C27.7936 19.4228 28.1947 19.2544 28.6347 19.2544C29.7462 19.2544 30.3862 20.1676 30.3862 21.2109C30.3862 22.2154 29.6881 23.0966 28.6409 23.0966ZM28.4144 20.2587C27.8978 20.2587 27.5155 20.6669 27.5155 21.1787C27.5155 21.6843 27.9041 22.0922 28.4144 22.0922C28.9252 22.0922 29.3133 21.6843 29.3133 21.1787C29.3133 20.6669 28.9318 20.2587 28.4144 20.2587Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.6501 26.004V28.7832H11.577V26.004H11.0469V25.1876H11.577V23.9888H12.6501V25.1876H13.1673V26.004H12.6501Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1907 28.8938C14.092 28.8938 13.2578 28.0837 13.2578 26.9822C13.2578 25.8807 14.092 25.0708 15.1907 25.0708C16.2895 25.0708 17.1236 25.8807 17.1236 26.9822C17.1236 28.0837 16.2895 28.8938 15.1907 28.8938ZM15.1907 26.0752C14.6928 26.0752 14.3309 26.4964 14.3309 26.9822C14.3309 27.4682 14.6928 27.8893 15.1907 27.8893C15.6884 27.8893 16.0505 27.4682 16.0505 26.9822C16.0505 26.4964 15.6884 26.0752 15.1907 26.0752Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.9542 28.3688C21.4628 28.7899 21.0103 28.7837 20.3899 28.7837H18.8706V23.9888H20.3444C20.9199 23.9888 21.4628 23.9954 21.8767 24.4553C22.0771 24.6758 22.1612 24.9477 22.1612 25.2458C22.1612 25.6537 21.9605 26.0104 21.6048 26.2113C22.1292 26.3925 22.394 26.7816 22.394 27.3255C22.394 27.7079 22.2515 28.1162 21.9542 28.3688ZM20.5121 24.9886H19.9437V25.8854H20.5041C20.823 25.8854 21.0874 25.7919 21.0874 25.4247C21.0874 25.0583 20.815 24.9886 20.5121 24.9886ZM20.6488 26.7684H19.9437V27.7727H20.6418C20.9904 27.7727 21.3019 27.6536 21.3019 27.2443C21.3019 26.8504 20.9757 26.7684 20.6488 26.7684Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0865 28.7832V28.4011H25.0734C24.8863 28.7899 24.5434 28.9003 24.1429 28.9003C23.748 28.9003 23.3478 28.7642 23.0886 28.4463C22.7979 28.0835 22.7659 27.7856 22.7659 27.3388V25.1875H23.8388V27.1765C23.8388 27.5847 23.9295 27.8958 24.4144 27.8958C24.86 27.8958 25.0278 27.5784 25.0278 27.1638V25.1875H26.1011V28.7832H25.0865Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.2876 29.9821H27.1495L27.7186 28.6022L26.3867 25.1875H27.5309L28.2487 27.2739H28.2616L28.9468 25.1875H30.0843L28.2876 29.9821Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9997 34.4683C12.5973 34.4683 6.59377 28.4524 6.59377 21.0308C6.59377 13.609 12.5973 7.59578 19.9997 7.59578C27.4033 7.59578 33.4049 13.609 33.4049 21.0308C33.4049 28.4524 27.4033 34.4683 19.9997 34.4683ZM19.9999 6.8584C12.2005 6.8584 5.85547 13.218 5.85547 21.0349C5.85547 28.8523 12.2005 35.2117 19.9999 35.2117C27.7991 35.2117 34.1448 28.8523 34.1448 21.0349C34.1448 13.218 27.7991 6.8584 19.9999 6.8584Z"
                fill="#009394"
            />
        </svg>
    );
};

export default HelpToBuyWithTextLogo;
